export default "__VITE_ASSET__ByIbZXQg__"